import { LoadingShim } from "@narmi/design_system";
import cc from "classcat";
import { CSSProperties, ReactNode, useRef } from "react";
import styles from "./PageLayout.module.css";

interface PageLayoutProps {
  children: ReactNode;
  style?: CSSProperties;
  className?: string;
  isLoading?: boolean;
}

function PageLayout({ isLoading, ...props }: PageLayoutProps) {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <div ref={ref} style={{ width: "100%", display: "flex", flexDirection: "column", flex: 1 }}>
      {isLoading ? (
        <LoadingShim isLoading>
          <div style={{ height: ref.current?.clientHeight }}></div>
        </LoadingShim>
      ) : (
        <div style={props.style} className={cc([styles.pageLayout, props.className])}>
          {props.children}
        </div>
      )}
    </div>
  );
}

export { PageLayout };
